module.exports = __webpack_public_path__ + "static/media/GB.3945f6b9.png";